import React, { createContext, useContext, useReducer } from 'react';

const QuizContext = createContext();

const quizReducer = (state, action) => {
    switch (action.type) {
        case 'UPDATE_ANSWER':
            const blockUpdate = {
                ...state,
                groups: state.groups.map(group => {
                    return {
                        ...group,
                        questions: group.questions.map(question =>
                            question.id_question === action.payload.questionId
                                ? {
                                    ...question,
                                    answers: question.answers.map(answer =>
                                        answer.id_answer === action.payload.answerId
                                            ? { ...answer, selected: true }
                                            : { ...answer, selected: false, user_answer: null }
                                    )
                                }
                                : question
                        )
                    }
                })
            };
            console.log(blockUpdate);
            return blockUpdate;
        case 'UPDATE_INFO':
            return {
                ...state,
                groups: state.groups.map(group =>
                    group.id_group === action.payload.groupId
                        ? { ...group, info: action.payload.info }
                        : group
                )
            };
        case 'SET_INITIAL_DATA':
            return action.payload;
        default:
            return state;
    }
};

export const QuizProvider = ({ children, initialData }) => {
    const [state, dispatch] = useReducer(quizReducer, initialData);

    return (
        <QuizContext.Provider value={{ state, dispatch }}>
            {children}
        </QuizContext.Provider>
    );
};

export const useQuiz = () => useContext(QuizContext);